import { useContext } from 'react';

import UserContext from 'context/userContext';

export function useCanAccessDistrolists(): boolean {
  const user = useContext(UserContext);

  if (!user?.company?.distrolistsEnabled) return false;

  return user?.permissions?.includes('DISTROLISTS_READ_ALL') ?? false;
}
